const colors = {
  'primary-light': '#E6F0F2',
  'primary-main': '#002C3D',
}

export default colors
